<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      title="全部订单"
      :z-index="10"
      @click-left="goableBack()"></van-nav-bar>
    <div class="list-contain">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad">
          <van-cell
            v-for="item in dataSource"
            :key="item.id"
            class="cell-2"
            @click="onOderDetail(item)">
            <div class="top-bg">
              <div class="c2-1">
                {{ dateFormat(item.createTime, "YYYY年MM月DD日 HH:mm:ss") }}
              </div>
              <div class="c2-1-1" v-if="item.isCashCoupon">
                {{ item.rebackStatus }}
              </div>
              <!-- <div class="c2-1-1" v-else>
                {{ item.waybillStatus }}
              </div> -->
            </div>
            <div class="order-address" v-if="item.address">
              <div>收货地址：{{ item.address || "" }}</div>
              <div
                v-if="item.waybillNo"
                id="waybillNo"
                :data-clipboard-text="item.waybillNo">
                <span>运单号：{{ item.waybillNo || "" }}</span>
                <van-tag
                  style="padding: 2px 10px; color: 12px; margin-left: 5px"
                  color="rgb(255, 255, 255)"
                  text-color="rgb(51, 51, 51)"
                  round
                  @click="onCopy('waybillNo')"
                  >复制</van-tag
                >
              </div>
              <div
                v-if="item.express"
                id="express"
                :data-clipboard-text="item.express">
                <span>快递公司：{{ item.express || "" }}</span>
                <van-tag
                  style="padding: 2px 10px; color: 12px; margin-left: 5px"
                  color="rgb(255, 255, 255)"
                  text-color="rgb(51, 51, 51)"
                  round
                  @click="onCopy('express')"
                  >复制</van-tag
                >
              </div>
            </div>
            <div class="c2-2">
              <img :src="item.coverImg" alt="商品图片" fit="cover" />
              <div class="c2-3">
                <div
                  class="c2-4"
                  :class="item.isCashCoupon ? 'cash-coupon' : ''">
                  {{ item.name }}&nbsp; {{ item.title }}
                </div>
                <div class="c2-5">
                  <div class="c2-6">
                    <span>{{ ((item.amount || 0) / 100).toFixed(2) }}</span>
                    <span class="unit">元</span>
                    <span>+{{ item.totalScore }}</span>
                    <span class="unit">积分</span>
                  </div>
                  <div class="c2-7">x{{ item.num }}</div>
                </div>
              </div>
            </div>
            <van-icon
              v-if="item.isCashCoupon"
              class="icon-arrow"
              name="arrow" />
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { Cell, Dialog, Icon, List, PullRefresh, Tag, Toast } from "vant"
import * as MallApi from "@/api/mall"
import ClipboardJS from "clipboard"
export default {
  name: "allorder",
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      refreshing: false,
      finished: false,
      loading: false,
      error: false,
      params: {
        pageNum: 1,
        pageSize: 10
      },
      dataSource: []
    }
  },
  methods: {
    onRefresh() {
      this.params.pageNum = 1
      //清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    onLoad() {
      MallApi.getGoodsCustOrderList(this.params)
        .then((data) => {
          if (data) {
            this.loading = false
            if (this.params.pageNum === 1) {
              this.finished = false
              this.dataSource = data
              //赋值给数据源
            } else {
              this.dataSource = this.dataSource.concat(data)
            }
            if (data.length < this.params.pageSize) {
              this.finished = true
            } else {
              this.params.pageNum++
            }
            this.refreshing = false
          }
        })
        .catch((e) => {
          this.loading = false
          this.finished = true
          this.$toast(e.msg || e.message)
        })
    },
    onOderDetail(item) {
      // item.availableExchange 是否可撤销
      if (item.isCashCoupon) {
        // 是否代金券
        this.$router.push({
          name: "orderDetail",
          params: { item: JSON.stringify(item) }
        })
      }
    },
    onCopy(elementId) {
      let clipboard = new ClipboardJS(`#${elementId}`)
      clipboard.on("success", function (e) {
        Toast("已经复制到您的剪切板")
        e.clearSelection()
      })
      clipboard.on("error", function (e) {
        Toast("不支持自动复制，请手动复制")
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  background-color: white;
}
.list-contain {
  margin: 10px 30px;
  margin-bottom: 0px;
  .cell-2 {
    margin-bottom: 15px;
    border-radius: 10px;
    background-color: rgb(236, 237, 239);
    .top-bg {
      display: flex;
      justify-content: space-between;
      .c2-1 {
      }
      .c2-1-1 {
        color: rgb(226, 152, 56);
      }
    }
    .c2-2 {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    img {
      flex: 0.6;
      width: 110px;
      height: 70px;
      border-radius: 10px;
      margin-right: 15px;
    }
    .c2-3 {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
    }
    .c2-4 {
      font-weight: 500;
      margin-top: 5px;
    }
    .cash-coupon {
      margin-right: 15px;
    }
    .c2-5 {
      display: flex;
      justify-content: space-between;
      margin-top: 5px;
      .c2-6 {
        color: rgb(188, 26, 32);
        .unit {
          font-size: 10px;
        }
      }
    }
    .icon-arrow {
      position: absolute;
      right: 0;
      top: calc(50% - 8px);
    }
  }
}
</style>